import React from 'react';
import PropTypes from 'prop-types';
import MainAdUnitContainer
from '@fuww/library/src/Advertisement/MainAdUnitContainer';
import { MobileAdUnitContainer }
from '@fuww/library/src/Advertisement/AdUnitContainer';
import { useSiteContext } from '../../SiteContext';
import AdUnit, { hasAdunit } from '../../../lib/adunit';
import InView from '../../InView';
import MoreNewsSection from './MoreNews';
import MoreNewsCardBlock from './MoreNews/MoreNewsCardBlock';

const hasMoreNews = (newsboard) => newsboard && !([
  'FASHIONUNITED_INFO',
].includes(newsboard));

const moreNewsRows = [MoreNewsCardBlock, MoreNewsCardBlock, MoreNewsCardBlock];

const AdditionalNewsSections = ({
  moreNewsVariables,
  notInIds,
  showCreatedAt,
  expandedSections,
  showLoader,
  categorySection,
  wfbAds,
}) => {
  const { newsboard } = useSiteContext();

  return (
    <>
      {hasAdunit(newsboard) && (
        <MainAdUnitContainer>
          <AdUnit
            adUnit="home_leaderboard1"
            sizes={[[1, 1], [728, 90], [970, 90], [970, 250]]}
            minHeight="90px"
          />
        </MainAdUnitContainer>
      )}
      {hasMoreNews(newsboard) && (
        <MoreNewsSection
          notInIds={notInIds}
          variables={{
            ...moreNewsVariables,
            notInIds,
          }}
          skip={showLoader}
          showCreatedAt={showCreatedAt}
          rows={expandedSections ? moreNewsRows : undefined}
        />
      )}
      {wfbAds}
      {hasAdunit(newsboard) && (
        <>
          <MainAdUnitContainer>
            <AdUnit
              adUnit="home_leaderboard2"
              sizes={[[1, 1], [728, 90], [970, 90], [970, 250]]}
              minHeight="90px"
            />
          </MainAdUnitContainer>
          <MobileAdUnitContainer>
            <AdUnit
              adUnit="mobile_home_categories_above"
              sizes={[[320, 240], [300, 250]]}
              minHeight="240px"
            />
          </MobileAdUnitContainer>
        </>
      )}
      {categorySection && (
        <InView>
          {categorySection}
        </InView>
      )}
      {hasAdunit(newsboard) && (
        <MobileAdUnitContainer>
          <AdUnit
            adUnit="mobile_home_categories_below"
            sizes={[[320, 240], [300, 250]]}
            minHeight="240px"
          />
        </MobileAdUnitContainer>
      )}
    </>
  );
};

AdditionalNewsSections.propTypes = {
  variables: PropTypes.shape({}).isRequired,
  moreNewsVariables: PropTypes.shape({}),
  notInIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  showCreatedAt: PropTypes.bool,
  expandedSections: PropTypes.bool.isRequired,
  showLoader: PropTypes.bool,
  categorySection: PropTypes.node,
  wfbAds: PropTypes.node,
};

AdditionalNewsSections.defaultProps = {
  categorySection: null,
  wfbAds: null,
  moreNewsVariables: {},
  showCreatedAt: false,
  showLoader: true,
};

export default AdditionalNewsSections;
